import { closeMobileMenu } from "./mobile-menu";

declare const $: any;


export function scrollTo(selector: string | Element, speed: number = 500) {
    let scrollOffset = 80;
    if(document.body.clientWidth < 950) {
        closeMobileMenu();
        scrollOffset = 0;
    }

    const targetElement = $(selector);

    if(targetElement && typeof targetElement.offset == 'function' && targetElement.offset()) {

        if(speed == 0) {
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            $('html, body').scrollTop( targetElement.offset().top - scrollOffset );
        } else {
            $('html, body').animate({ scrollTop: targetElement.offset().top - scrollOffset }, speed);
        }

    }
}
